import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Input } from 'antd';
import { initAMap, BDMapToGDMap, GDMapToBDMap } from 'utils';

import './index.less';
const prefix = 'eh-baidu-map-choose-address';

class BaiduMap extends Component {
	static defaultProps = {
		title: '请选择地址'
	};

	constructor(props) {
		super(props);
		this.state = {
			lnlgValue: {}, //经纬度值 {lat,lng}
			locationName: '', //地址信息
			address: '',
			map: null //地图对象
		};
	}

	componentWillReceiveProps(next) {
		const { state } = this;
		if (next.visible && this.props.visible !== next.visible) {
			this.setState({}, () => {
				initAMap().then(() => {
					this.initMap();
				});
			});
		}

		const AMap = getWindow().AMap;
		if (!AMap) return;

		if (next.locationName === '' && state.map) {
			state.map.setZoomAndCenter(11, [113.951065, 22.535635]); // 初始化地图,设置中心点坐标和地图级别
			state.map.setCity('深圳市'); // 设置地图显示的城市 此项是必须设置的
			// 通过浏览器定位当前坐标
			AMap.plugin('AMap.Geolocation', () => {
				const geolocation = new AMap.Geolocation({ enableHighAccuracy: true });
				geolocation.getCurrentPosition((status, result) => {
					if (status === 'complete' && state.map) {
						const marker = new AMap.Marker({
							position: result.position
						});
						state.map.clearMap();
						state.map.add(marker);
						state.map.panTo(result.position);
					}
				});
			});
		}
	}

	initMap = () => {
		const AMap = getWindow().AMap;

		setTimeout(() => {
			const containerId = this.props && this.props.containerId;
			let propLon;
			let propLat;
			if (
				this.props &&
				this.props.initialCenter &&
				this.props.initialCenter.longitude &&
				this.props.initialCenter.latitude
			) {
				const { lng, lat } = BDMapToGDMap({ lng: this.props.initialCenter.longitude, lat: this.props.initialCenter.latitude });
				propLon = lng;
				propLat = lat;
			}
			const map = new AMap.Map(containerId ? 'eh_map_' + containerId : 'eh_map', {
				viewMode: '2D', // 默认使用 2D 模式，如果希望使用带有俯仰角的 3D 模式，请设置 viewMode: '3D',
				zoom: propLon && propLat ? 16 : 11, //初始化地图层级
				center: [propLon || 113.951065, propLat || 22.535635] //初始化地图中心点
			});
			map.setCity('深圳市'); // 设置地图显示的城市 此项是必须设置的

			let geoc;
			AMap.plugin(['AMap.Geocoder', 'AMap.Geolocation', 'AMap.AutoComplete'], () => {
				geoc = new AMap.Geocoder();

				if (propLat && propLon) {
					const position = new AMap.LngLat(propLon, propLat);
					const marker = new AMap.Marker({
						position
					});
					map.clearMap();
					map.add(marker);
					map.panTo(position);
				} else {
					const geolocation = new AMap.Geolocation({ enableHighAccuracy: true });
					geolocation.getCurrentPosition((status, result) => {
						if (status === 'complete') {
							const marker = new AMap.Marker({
								position: result.position
							});
							map.clearMap();
							map.add(marker);
							map.panTo(result.position);
						}
					});
				}

				// 地图点击事件
				map.on('click', e => {
					this.setState({ searchValue: '' });
					const { lnglat } = e;
					geoc.getAddress([lnglat.lng, lnglat.lat], (status, result) => {
						if (status === 'complete' && result.info === 'OK') {
							// result为对应的地理位置详细信息
							const marker = new AMap.Marker({
								position: [lnglat.lng, lnglat.lat]
							});
							map.clearMap();
							marker.setMap(map);
							this.setState({
								address: result.regeocode.formattedAddress,
								lnlgValue: { lng: lnglat.lng, lat: lnglat.lat }, //经纬度值
								locationName: result.regeocode.formattedAddress
							});
						}
					});
				});

				//	输入提示
				const autoOptions = {
					input: containerId ? 'suggestId_' + containerId : 'suggestId'
				};
				const autocomplete = new AMap.AutoComplete(autoOptions);
				autocomplete.on('select', e => {
					const { lat, lng } = e.poi.location;
					const marker = new AMap.Marker({
						position: [lng, lat]
					});
					const address = `${e.poi.district}-${e.poi.address}-${e.poi.name}`;
					map.clearMap();
					map.add(marker);
					map.setCenter([lng, lat]);
					this.setState({
						locationName: address,
						address: address,
						lnlgValue: { lng, lat },
						map,
						searchValue: e.poi.name
					});
				});
			});

			// 添加类别切换控件
			if (this.props.showMapType) {
				AMap.plugin(['AMap.MapType'], () => {
					map.addControl(new AMap.MapType());
				});
			}
		}, 0);
	};

	// 地名改变
	changeAddName = e => {
		this.setState({
			locationName: e.target.value
		});
	};

	inputChange = e => {
		this.setState({
			searchValue: e.target.value
		});
	};

	render() {
		const { props, state } = this;
		const { visible, title, changeAddressAble, uneditable, containerId = 'eh_map' } = props;
		const { lnlgValue, locationName, address, map, searchValue } = this.state;
		return (
			<Modal
				width={666}
				title={title}
				visible={visible}
				onCancel={() => {
					this.setState({ searchValue: '' });
					this.props.onCancel();
				}}
				destroyInvisibleModal={true}
				destroyOnClose
				footer={uneditable && null}
				onOk={() => {
					this.setState({ searchValue: '' });
					this.props.onOk({ locationName, lnlgValue: GDMapToBDMap(lnlgValue), map, addressDetail: address });
				}}
			>
				<div>
					<div id={containerId ? 'eh_map_' + containerId : 'eh_map'} className={prefix} />
					<div className={prefix + '-search'}>
						<Input
							value={searchValue}
							id={containerId ? 'suggestId_' + containerId : 'suggestId'}
							type="text"
							placeholder="搜索地点"
							className={`${prefix}-inp`}
							onChange={e => this.setState({ searchValue: e.target.value })}
						/>
					</div>
					<div
						id={containerId ? 'searchResultPanel_' + containerId : 'searchResultPanel'}
						className={prefix + '-panel'}
					/>
					{changeAddressAble && (
						<div className={`${prefix}-address`}>
							<div>
								<span>地名：</span>
								<Input
									placeholder="请输入具体地名"
									value={state.locationName}
									onChange={this.changeAddName}
									style={{
										width: 250
									}}
								/>
							</div>
							<div style={{ marginTop: 16 }}>
								<span>地址：</span>
								<span
									style={{
										display: 'inline-block'
									}}
								>
									{state.address}
								</span>
							</div>
						</div>
					)}
				</div>
			</Modal>
		);
	}
}

BaiduMap.propTypes = {
	//组件的回调函数
	onCancel: PropTypes.func,
	onOk: PropTypes.func,
	visible: PropTypes.bool,
	changeAddressAble: PropTypes.bool,
	title: PropTypes.string,
	containerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	uneditable: PropTypes.bool,
	showMapType: PropTypes.bool // 是否显示类别切换控件
};
BaiduMap.defaultProps = {
	onCancel: () => {},
	onOk: () => {},
	visible: false,
	changeAddressAble: false, //是否允许修改地名
	title: '请选择地址',
	containerId: 'eh_map',
	uneditable: undefined,
	showMapType: false
};
export default BaiduMap;

// 获取全局对象
function getWindow() {
	if (typeof global !== 'undefined') {
		return global;
	}
	return window;
}
